"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApInput = void 0;
var React = require("react");
var ApIcon_1 = require("../ApIcon");
var ApInput_styles_1 = require("./ApInput.styles");
exports.ApInput = function (_a) {
    var className = _a.className, disabled = _a.disabled, errorMessage = _a.errorMessage, icon = _a.icon, label = _a.label, name = _a.name, maxLength = _a.maxLength, onChange = _a.onChange, placeholder = _a.placeholder, symbol = _a.symbol, value = _a.value, props = __rest(_a, ["className", "disabled", "errorMessage", "icon", "label", "name", "maxLength", "onChange", "placeholder", "symbol", "value"]);
    var _b = __read(React.useState(value ? value.length : 0), 2), valueLength = _b[0], setValueLength = _b[1];
    return (React.createElement(ApInput_styles_1.Wrapper, { className: className },
        label || maxLength ? (React.createElement(ApInput_styles_1.LabelWrapper, null,
            label ? React.createElement(ApInput_styles_1.Label, null, label) : null,
            maxLength ? (React.createElement(ApInput_styles_1.Counter, null,
                valueLength,
                "/",
                maxLength)) : null)) : null,
        React.createElement(ApInput_styles_1.InputWrapper, null,
            icon ? (React.createElement(ApInput_styles_1.RightSymbol, null,
                React.createElement(ApIcon_1.ApIcon, { iconName: icon }))) : null,
            symbol ? React.createElement(ApInput_styles_1.RightSymbol, null, symbol) : null,
            React.createElement(ApInput_styles_1.Input, __assign({ disabled: disabled, maxLength: maxLength || Infinity, name: name, onChange: function (e) {
                    onChange(e.target.value, e);
                }, onKeyUp: function (event) {
                    // @ts-ignore
                    setValueLength(event.target.value.length);
                }, placeholder: placeholder, value: value, className: "ap-input-field" }, props))),
        errorMessage ? (React.createElement(ApInput_styles_1.ErrorWrapper, null,
            React.createElement(ApInput_styles_1.ErrorMessage, null, errorMessage))) : null));
};
//# sourceMappingURL=ApInput.js.map